import type { ReactNode } from 'react'
import type { ImplementedRubricSpec, Role, Task } from '@/lib/types'
import { RubricView } from '@/components/RubricView'
import { TaskRubric } from '@/pages/scientific/TaskRubric'
import { ImplementedRubric, RubricNotes } from './ImplementedRubric'

/** The verifier's checks this comparison lists, if any: where a result row can link to. */
export function shownImplementedRubric(task: Task, implementedRubric?: ImplementedRubricSpec): ImplementedRubricSpec | undefined {
  if (task.scientific && implementedRubric) return implementedRubric
  const spec = task.authoring_submission?.handoff?.implemented_rubric
  return spec?.checks?.length ? spec : undefined
}

/** Compare the submitted rubric with its implementation, when a build is available. */
export function RubricComparison({ task, role, authorRubric, implementedRubric }: {
  task: Task; role: Role; authorRubric?: ReactNode; implementedRubric?: ImplementedRubricSpec
}) {
  // Scientific tasks have a compiled rubric, frozen with this QC round.
  if (task.scientific && implementedRubric) return <section className="box">
    <h3>Task rubric</h3><TaskRubric spec={implementedRubric} developer={role === 'engineer'} />
  </section>
  if (!shownImplementedRubric(task)) {
    return <><RubricNotes task={task} role={role} />{authorRubric ?? <RubricView rubric={task.rubric} layout={task.rubric_layout} />}</>
  }
  return <div className="rubric-comparison">
    <RubricNotes task={task} role={role} />
    <div className="rubric-comparison-columns">
      <section aria-label="Author’s rubric">
        <div className="implemented-heading"><h3>Author’s rubric</h3><span className="muted small">{task.rubric?.length ?? 0} criteria</span></div>
        {authorRubric ?? <RubricView rubric={task.rubric} layout={task.rubric_layout} />}
      </section>
      <ImplementedRubric task={task} role={role} showNotes={false} />
    </div>
  </div>
}
